const box = {
  width: '100%',
  padding: 16,
};

const title = {
  paddingBottom: 4,
  display: 'flex',
  alignItems: 'center',
  fontSize: 15,
  fontWeight: 500,
  justifyContent: 'space-between',
  flexShrink: 0,
  '& span': {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
};

const styles = (theme) => ({
  root: {
    ...box,
    height: '100%',
    marginBottom: 24,
  },

  noPadding: {
    padding: 0,
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  paddedTitle: {
    ...title,
    padding: 16,
  },

  title: {
    ...title,
    padding: theme.titlePadding,
    marginBottom: -theme.titlePadding,
  },
});

export default styles;
